import { render, staticRenderFns } from "./DownloadButton.vue?vue&type=template&id=06639f5b"
import script from "./DownloadButton.vue?vue&type=script&lang=js"
export * from "./DownloadButton.vue?vue&type=script&lang=js"
import style0 from "./DownloadButton.vue?vue&type=style&index=0&id=06639f5b&prod&lang=css"
import style1 from "./DownloadButton.vue?vue&type=style&index=1&id=06639f5b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports